jQuery(function($) {
  $('.accordion-block .accordion-item').click(function() {
    const accordionContent = $(this).children('.accordion-item--content');
    const accordionContentHeight = accordionContent[0].scrollHeight;
    const accordionContentNone = $('.accordion-item--content');

    $(this).siblings().removeClass('active');
    $(this).toggleClass('active');

    if($(this).hasClass('active')) {
      accordionContentNone.css('max-height', `0px`);
      accordionContent.css('max-height', `${accordionContentHeight}px`);

    } else {
      accordionContent.css('max-height', `0px`);
    }
  })
});


// Features Block
jQuery(function($) {
  const accordionItems = $('.features-accordion .accordion-item');

  if(accordionItems.length > 0) {
    const firstSingleFeaturesContent = $('.single-features-content').first();
    const firstSingleFeaturesContentInner = firstSingleFeaturesContent.children('.accordion-content--inner');
    const firstSingleFeaturesContentHeight = firstSingleFeaturesContentInner[0].scrollHeight;
    firstSingleFeaturesContent.addClass('active').css('max-height', `${firstSingleFeaturesContentHeight}px`);

    const firstAccordionItem = accordionItems.first();
    const firstAccordionContent = firstAccordionItem.children('.accordion-item--content');
    const firstAccordionContentHeight = firstAccordionContent[0].scrollHeight;
    firstAccordionItem.addClass('active');
    firstAccordionContent.css('max-height', `${firstAccordionContentHeight}px`);

    $('.single-features-content').first().addClass('active');

    $('.features-accordion .accordion-item').click(function() {
      const accordionContent = $(this).children('.accordion-item--content');
      const accordionContentHeight = accordionContent[0].scrollHeight;
      const accordionContentNone = $('.accordion-item--content');

      $(this).siblings().removeClass('active');
      $(this).addClass('active');

      const index = $(this).index();

      const singleFeaturesContent = $('.single-features-content').eq(index);
      const singleFeaturesContentInner = singleFeaturesContent.children('.accordion-content--inner');
      const singleFeaturesContentHeight = singleFeaturesContentInner[0].scrollHeight;
      singleFeaturesContent.removeClass('active').toggleClass('active').css('max-height', `${singleFeaturesContentHeight}px`);

      $('.single-features-content').not(singleFeaturesContent).css('max-height', '0');
      $('.single-features-content').not(singleFeaturesContent).removeClass('active');

      if($(this).hasClass('active')) {
        accordionContentNone.css('max-height', `0px`);
        accordionContent.css('max-height', `${accordionContentHeight}px`);

      } else {
        accordionContent.css('max-height', `0px`);
      }
    });
  }
});


// Process Block
jQuery(function($) {
  if($('.step').length > 0 && $('.step-content').length > 0) {
    const firstStep = $('.step').first();
    const firstStepContent = $('.step-content').first();
    const firstStepContentInner = firstStepContent.children('.wysiwyg');
    const firstStepContentHeight = firstStepContentInner[0].scrollHeight;

    firstStep.addClass('active');
    firstStepContent.addClass('active').css('max-height', `${firstStepContentHeight}px`);

    $('.step').click(function() {
      const index = $(this).index();

      $(this).siblings().removeClass('active');
      $(this).addClass('active');

      const stepContent = $('.step-content').eq(index);
      const stepContentInner = stepContent.children('.wysiwyg');
      const stepContentHeight = stepContentInner[0].scrollHeight;
      const stepContentNone = stepContent.siblings();

      stepContent.addClass('active');
      stepContentNone.removeClass('active');

      if(stepContent.hasClass('active')) {
        stepContentNone.css('max-height', `0px`);
        stepContent.css('max-height', `${stepContentHeight}px`);
      } else {
        stepContent.css('max-height', `0px`);
      }
    });
  }
});